import { type OutboxDatabase, openOutboxDb } from "./db";

let connection: Promise<OutboxDatabase> | null = null;
let running: Promise<unknown> = Promise.resolve();

function db(): Promise<OutboxDatabase> {
  if (connection === null) {
    connection = openOutboxDb();
  }
  return connection;
}

export function withDraftDb<T>(work: (opened: OutboxDatabase) => Promise<T>): Promise<T> {
  const next = running.then(async () => work(await db()));
  running = next.catch(() => undefined);
  return next;
}

export async function closeDraftDb(): Promise<void> {
  await running;
  const opened = connection;
  connection = null;
  if (opened !== null) {
    (await opened).close();
  }
}
